import React, { useCallback, useEffect } from 'react';
import { useNavigationType, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useBanner } from '../../hooks/bannerProvider';
import { useTitle } from '../../hooks/titleProvider';
import { Box } from '@mui/system';
import Overview from '../account/balancesView/components/overview';
import Products from '../account/balancesView/components/products';
import OrangeCircularProgress from '../ui/controls/circularProgress';
import {
  clearClient,
  getClientBalances,
  getClientById
} from '../../features/advisor/advisor.slice';
import { Typography } from '@mui/material';

const AdvisorClientAccounts = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const client = useSelector((state) => state.advisor.client.client);
  const account = useSelector((state) => state.advisor.client.account);
  const fetchingClient = useSelector((state) => state.advisor.client.fetchingClient);
  const fetchingBalances = useSelector((state) => state.advisor.client.fetchingBalances);
  const navigationType = useNavigationType();

  const { setTitle } = useTitle();
  const { setBanner } = useBanner();

  useEffect(() => {
    setBanner(null);
  }, [setBanner]);

  useEffect(() => {
    if (!client || client._id !== id) {
      dispatch(getClientById(id));
    }

    return () => {
      setTitle('');
    };
  }, [id, client, dispatch, setTitle, navigationType]);

  const memoizedSetTitle = useCallback(
    (title) => {
      setTitle(title);
    },
    [setTitle]
  );

  useEffect(() => {
    if (client) {
      if (client.firstName || client.entityName) {
        memoizedSetTitle(
          (client.firstName ? client.firstName : client.entityName || '') +
            ' ' +
            (client.lastName ?? '') || ''
        );
      } else if (client.idNumber) {
        memoizedSetTitle(client.idNumber);
      } else {
        memoizedSetTitle('Client');
      }
    }
  }, [client, memoizedSetTitle]);

  useEffect(() => {
    if (client && client._id === id) {
      dispatch(getClientBalances(client._id));
    }
  }, [client, dispatch, id]);

  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'center'}>
      {!fetchingBalances ? (
        <Box width={'100%'} maxWidth={'700px'}>
          {/* <Overview account={account} title={`Fairtree`} /> */}
          {account ? (
            <Products account={account} advisor={true} />
          ) : (
            <Typography variant="h5" color="text.secondary" align="center">
              No accounts available.
            </Typography>
          )}
        </Box>
      ) : (
        <OrangeCircularProgress caption="Fetching your profile summary." />
      )}
    </Box>
  );
};

export default AdvisorClientAccounts;
